import createStaticResourceAPI from "@/helpers/rtk_static_resource_factory";

const baseURL = process.env.REACT_APP_GLOBO_API + '/transactions/doctorEnrollments';
const type = "DoctorEnrollments";

export const doctorEnrollmentsAPI = createStaticResourceAPI({
  baseURL: baseURL,
  resource: "DoctorEnrollments",
  tagTypes: ["DoctorEnrollments"],
  idKey: "doctorEnrollmentId",
  lookupMap: ({ doctorEnrollmentId, referenceNo }) => ({
    value: doctorEnrollmentId,
    label: referenceNo
  }),
  customQuery: (query, { idKey, resource, baseURL }) => ({
    getListDoctorEnrollmentsForViewers: query(`${baseURL}/listForViewer`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) => {
        if (!result?.success || !Array.isArray(result.returnData)) {
          return [{ type: resource, id: "LIST" }];
        }

        return [
          ...result.returnData.map((item) => ({
            type: resource,
            id: item[idKey],
          })),
          { type: resource, id: "LIST" },
        ];
      }
    }),

     getFilesDoctorEnrollments: query(`${baseURL}/files/list`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) =>
        result?.success
          ? [...(result?.items || result?.returnData)?.map((item) => ({ type: type, id: item[idKey] })), { type: type, id: type }]
          : [{ type: type, id: type }],
    }),
  }),
  customMutations: (mutation, mutationOptions) => ({
    submitDoctorEnrollments: mutation(`${baseURL}/submit`, mutationOptions("save")),
    returnDoctorEnrollments: mutation(`${baseURL}/return`, mutationOptions("save")),
    approveDoctorEnrollments: mutation(`${baseURL}/approve`, mutationOptions("save")),
    rejectDoctorEnrollments: mutation(`${baseURL}/reject`, mutationOptions("save")),
    cancelDoctorEnrollments: mutation(`${baseURL}/cancel`, mutationOptions("save")),
     filesUploadDoctorEnrollments: mutation(`${baseURL}/files/upload`),
    filesDeleteDoctorEnrollments: mutation(`${baseURL}/files/delete`),
  
  }),
});

export const {
  useGetDoctorEnrollmentsQuery,
  useGetListDoctorEnrollmentsForViewersQuery,
  useExportDoctorEnrollmentsMutation,
  useFindDoctorEnrollmentsQuery,
  useLookUpDoctorEnrollmentsMutation,
  useSaveDoctorEnrollmentsMutation,
  useSubmitDoctorEnrollmentsMutation,
  useReturnDoctorEnrollmentsMutation,
  useApproveDoctorEnrollmentsMutation,
  useRejectDoctorEnrollmentsMutation,
  useCancelDoctorEnrollmentsMutation,
  useDeleteDoctorEnrollmentsMutation,
   useFilesUploadDoctorEnrollmentsMutation,
  useFilesDeleteDoctorEnrollmentsMutation,
  useGetFilesDoctorEnrollmentsQuery
} = doctorEnrollmentsAPI;
